<!-- <script src="../vendor/leaflet-bubble.js"></script> -->
<script>
import { onMount } from 'svelte';
import { hospitals, monthRefs } from '../common.js';

import bikeStations from '../../data/bike-station-locations/index.json'

export let title = 'Map Title'
export let bottomMargin = false;
export let mapid = 'mapid'
export let bgCssClass = 'bg-primary'
export let markerColor = '#18C7DE'
export let countfield = 'count'
export let data = {};
export let stationIdField = 'startstationid'

export let currentType = 'all';
export let monthNo = 1;

$ : list = (currentType === 'all') ? data.all : data.bymonth[monthNo]

let mymap;
let cmarkers = []

function showAll () {
  currentType = 'all'
  setTimeout(() => addData2Map(), 300)
}
function updateMonth (no = 1) {
  monthNo = no
  currentType = 'month'
  setTimeout(() => addData2Map(), 300)
}

function addData2Map () {
  cmarkers.forEach(m => {
    mymap.removeLayer(m);
  })
  list.slice(0,100).forEach(x => {
    let validStation = bikeStations[x[stationIdField]]
    if (!validStation) {
      return false
    }
    let latLng = [ Number(validStation.lat), Number(validStation.lon) ]
    let circle = L.circleMarker(latLng, {
        color: '#555',
        fillColor: markerColor,
        fillOpacity: 0.9,
        opacity: 0.3,
        // stroke: false,
        radius: (currentType === 'all') ? x[countfield]/1200 : x[countfield]/300
        // radius: x.total/70
    })
    .addTo(mymap)
    .on('mouseover', function(e) {
      var popup = L.popup()
      // .setLatLng(e.latlng)
      .setLatLng(latLng)
      .setContent(`<strong>Station: </strong>${validStation.title}<br><strong>Total: </strong>${Number(x[countfield]).toLocaleString()}`)
      .openOn(mymap);
    })
    .on('mouseout', function(e) {
      mymap.closePopup();
    });
    cmarkers.push(circle)
  })
}

onMount(async () => {
  mymap = L.map(mapid, {
      // zoomControl: false,
      minZoom: 11,
      maxZoom: 17,
      scrollWheelZoom: false
    }).setView([51.505, -0.09], 12);
  mymap.zoomControl.setPosition('topright');


  L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      maxZoom: 18,
      id: 'mapbox/light-v10',
      tileSize: 512,
      zoomOffset: -1,
      accessToken: 'pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw'
  }).addTo(mymap);

  // add hospitals
  hospitals.forEach(h => {
    L.marker([h.lat, h.lng], {
        icon: L.divIcon({ className: 'map-hospital', iconSize: [33, 33], iconAnchor: [16, 33], html: '<div style="font-size:20px"><i class="fas fa-hospital-symbol"></i></div>'}),
      })
      .on('click', function(e) {
        var popup = L.popup()
        .setLatLng([h.lat, h.lng])
        .setContent(`<strong>Hospital: </strong>${h.name}`)
        .openOn(mymap);
      })
      .addTo(mymap);
  })

  addData2Map()

});

</script>

<section class="{`${bgCssClass} sectionx hero is-fullheight ${(bottomMargin) ? 'show-bottom-margin' : ''}`}">
  <div class="padding-scroll-top"></div>
  <!-- <div class="padding-scroll-right"></div> -->
  <div class="padding-scroll-bottom"></div>
  <div class="padding-scroll-left"></div>
  <div class="title">{title}</div>
  <div class="map" id="{mapid}"></div>
  <div class="controls">
    <div class="buttonsa">
      <button
        class:is-link="{currentType === 'all'}"
        class="button is-small"
        on:click={() => showAll()}>All</button>
      {#each Array(8) as _, i}
        <button
          class:is-link="{currentType === 'month' && monthNo === (i+1)}"
          class="button is-small"
          on:click={() => updateMonth(i+1)}>{monthRefs[i].abbr}</button>
      {/each}
    </div>
  </div>
</section>


<style>
.map {
  height: 50vh;
  width: 100%;
  border: solid 1px #fff;
  /* margin-bottom: 1vh; */
}
.show-bottom-margin .map {
  height: 49vh;
}

.title {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 9999;
  font-size: 1rem;
  font-weight: bold;
  text-transform: uppercase;
  padding: 3px 2px;
  background-color: rgba(255,255,255,.5);
  /* text-shadow: 2px 2px 2px rgba(0,0,0,.5); */
}
.controls {
  position: absolute;
  top: 60px;
  left: 20px;
  z-index: 9999;
  font-size: 1rem;
  font-weight: bold;
  text-transform: uppercase;
  padding: 3px 2px;
  background-color: rgba(255,255,255,.5);
  /* text-shadow: 2px 2px 2px rgba(0,0,0,.5); */
}

.controls .button {
  display: block;
  text-transform: uppercase;
  width: 60px;
}
section {
  position: relative;
  height: 50vh;
  min-height: 50vh !important;
}
</style>